import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Routes as AppRoutes } from '@core/routes/routes';
import { AuthService, UserRole } from '../services/auth-service';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Verificar autenticación
  if (!authService.isAuthenticated()) {
    return router.createUrlTree([AppRoutes.loginPage]);
  }

  // Los ADMIN tienen todos los permisos
  if (authService.hasRole(UserRole.ADMIN)) {
    return true;
  }

  // Obtener los permisos requeridos de la configuración de la ruta
  const requiredPermissions = route.data['permissions'] as string[];
  const requireAll = route.data['requireAll'] as boolean ?? false;

  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  // Validar permisos
  const hasAccess = requireAll 
    ? authService.hasAllPermissions(requiredPermissions)
    : authService.hasAnyPermission(requiredPermissions);

  if (hasAccess) {
    return true;
  }

  return router.createUrlTree([AppRoutes.dashboardPage]);
};
